import { useLanguage } from "@/lib/LanguageContext";
import { useReveal } from "@/lib/useReveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  const { t } = useLanguage();
  const ref = useReveal();

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="px-6 sm:px-12 lg:px-24 py-24 sm:py-32"
    >
      <div className="grid lg:grid-cols-12 gap-12">
        <div ref={ref} className="reveal lg:col-span-5">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#D97736] mb-4">
            {t.faq.overline}
          </p>
          <h2 className="font-display font-bold text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
            {t.faq.title}
          </h2>
        </div>

        <div className="lg:col-span-7">
          <Accordion type="single" collapsible className="w-full">
            {t.faq.items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-[#2C2F36]"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-display font-bold text-white text-lg sm:text-xl tracking-tight py-6 hover:no-underline hover:text-[#D97736] data-[state=open]:text-[#D97736]"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="text-[#A0AAB2] text-base leading-relaxed pb-6 pr-8"
                >
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
